<table
  #tablePlaceholder
  class="userManagementTable__placeholder"
  aria-label="Account User Management Placeholder"
>
  <div class="userManagementTable__placeholder-header-item">&nbsp;</div>
  @for (placeholder of linesArray; let index = $index; track index) {
    <tr class="userManagementTable__placeholder--row">
      <div class="userManagementTable__placeholder--cell">
        <div class="userManagementTable__placeholder-item">&nbsp;</div>
      </div>
    </tr>
  }
</table>
